import React, { useState } from 'react';

const RaiseHandButton = ({ socketRef, roomId, nickname }) => {
  const [isRaised, setIsRaised] = useState(false);

  const toggleRaiseHand = () => {
    const newState = !isRaised;
    setIsRaised(newState);
    
    if (socketRef.current) {
      socketRef.current.emit('raise-hand', roomId, socketRef.current.id, newState, nickname);
    }

    // Show notification
    showNotification(newState ? '✋ You raised your hand' : '✋ Hand lowered');
  };

  const showNotification = (message) => {
    const toast = document.createElement('div');
    toast.style.cssText = `
      position: fixed;
      top: 80px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 12px 24px;
      border-radius: 8px;
      z-index: 9999;
      backdrop-filter: blur(10px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
    `;
    toast.textContent = message;
    document.body.appendChild(toast);
    setTimeout(() => document.body.removeChild(toast), 3000);
  };

  return (
    <button
      onClick={toggleRaiseHand}
      className={`zoom-control-btn raise-hand-btn ${isRaised ? 'active' : 'inactive'}`}
      title={isRaised ? 'Lower Hand' : 'Raise Hand'}
    >
      <span className="control-icon" aria-hidden="true">
        ✋
      </span>
      <span className="control-label">{isRaised ? 'Lower Hand' : 'Raise Hand'}</span>
    </button>
  );
};

export default RaiseHandButton;


